var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "wz_viewListAgents" },
    [
      _c(
        "v-toolbar",
        { staticClass: "accent", attrs: { dark: "", dense: "" } },
        [_c("v-toolbar-title", [_vm._v(_vm._s(_vm.$t("listOfAgents")))])],
        1
      ),
      _vm._v(" "),
      _vm.routeNameMonitoring
        ? _c(
            "div",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              staticClass: "ContentListeAgents"
            },
            [
              _vm.listeAgents.length
                ? _c(
                    "v-expansion-panel",
                    { attrs: { focusable: "" } },
                    [
                      _vm._l(_vm.listeAgents, function(itemAgent, i) {
                        return _c(
                          "v-expansion-panel-content",
                          {
                            key: i,
                            nativeOn: {
                              click: function($event) {
                                return _vm.selectAgent(itemAgent)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c("wz-watcheebox-agent", {
                                  attrs: { datasAgent: itemAgent },
                                  on: {
                                    loading: function($event) {
                                      _vm.loading = true
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list",
                              { staticClass: "listeChatsAgents" },
                              [
                                _vm._l(_vm.sessionsChatAgent, function(
                                  itemChat
                                ) {
                                  return _c(
                                    "div",
                                    { key: itemChat[0] },
                                    [
                                      _c(
                                        "v-list-tile",
                                        {
                                          class: {
                                            "grey lighten-5":
                                              _vm.chatSelected === itemChat[0]
                                          },
                                          attrs: { ripple: "" }
                                        },
                                        [
                                          itemChat[5] === "online"
                                            ? _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    medium: "",
                                                    color: "light-green"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    textsms\n                  "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    medium: "",
                                                    color: "red"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    mode_comment\n                  "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c(
                                                "v-list-tile-title",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.updateChat(
                                                        itemChat
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$tc("visitors", 1, {
                                                          count: ""
                                                        })
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-sub-title",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.updateChat(
                                                        itemChat
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(itemChat[0]) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.loading
                        ? _c(
                            "v-container",
                            { attrs: { "fill-height": "" } },
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    flex: "",
                                    "align-center": "",
                                    "justify-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("v-progress-circular", {
                                            staticClass: "primary--text",
                                            attrs: {
                                              indeterminate: "",
                                              size: 100,
                                              width: 1
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _c("div", { staticClass: "listeAgentsEmpty" }, [
                    _vm._v("Aucun agent disponible")
                  ])
            ],
            1
          )
        : _c(
            "div",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              staticClass: "ContentListeAgentsClassic"
            },
            [
              _vm.listeAgents.length
                ? _c(
                    "v-list",
                    { staticClass: "listeAgents" },
                    [
                      _vm._l(_vm.listeAgents, function(item, i) {
                        return _c(
                          "div",
                          { key: i },
                          [
                            _c("wz-watcheebox-agent", {
                              attrs: { datasAgent: item },
                              on: {
                                loading: function($event) {
                                  _vm.loading = true
                                }
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.selectAgent(item)
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.loading
                        ? _c(
                            "v-container",
                            { attrs: { "fill-height": "" } },
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    flex: "",
                                    "align-center": "",
                                    "justify-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("v-progress-circular", {
                                            staticClass: "primary--text",
                                            attrs: {
                                              indeterminate: "",
                                              size: 100,
                                              width: 1
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _c("div", { staticClass: "listeAgentsEmpty" }, [
                    _vm._v("Aucun agent disponible")
                  ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56d7f642", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56d7f642","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzListAgents.vue
// module id = null
// module chunks = 